<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 电脑导航 -->
    <div class="header-nav container visible-lg visible-md">
      <div class="container">
        <!-- 导航logo -->
        <div class="header-nav-logo">
          <img src="//cdncrystal.bluestonehk.com/images/logo@2x.png" />
        </div>
        <!-- 导航内容 -->
        <ul class="header-nav-wrapper">
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="item.path == $route.fullPath ? 'active' : ''"
            @click="navClick(index, item.name)"
          >
            <a :href="item.path">{{ item.name }}</a>
          </li>
        </ul>
        <!-- 用户导航 -->
        <ul class="header-nav-wrapper header-user-nav" v-if="!isLogin">
          <li>
            <a :href="loginUrl">登录</a>
          </li>
          <li>
            <a :href="registerUrl">注册</a>
          </li>
          <li>
            <div class="bs-btn"><a href="javascript:;" @click="openDialog">极速开户</a></div>
          </li>
        </ul>
        <!-- 登录后 内容 -->
        <ul class="header-nav-wrapper header-user-nav user-login" v-else>
          <li class="hover-box">
            <div class="user-name-box">
              <a href="javascript:;">{{ userInfo.nick_name }}</a>
              <i class="icon-arrow_white"></i>
            </div>
            <div class="user-hover-box">
              <ul class="sub-menu-list">
                <li>
                  <a href="/userCenter" class="highlight">
                    <i class="icon-account"></i>
                    <span>我的青石</span>
                  </a>
                </li>
                <li>
                  <a href="javascript:;" @click="logout">
                    <i class="icon-logout"></i>
                    <span>退出登录</span>
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <div class="bs-btn">
              <a href="javascript:;" @click="openDialog">{{ buttonObj && buttonObj.text }}</a>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild hidden-lg hidden-md">
      <div class="header-nav-m-logo">
        <img class="center-block" src="//cdncrystal.bluestonehk.com/images/logo@2x.png" alt="logo" />
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center" ref="mNav">
        <div class="header-nav-m-menu-wrapper" @click="menuClick">
          <div class="btn-menu" :class="menuBtnClass">
            <span class="line"></span>
            <span class="line"></span>
            <span class="line"></span>
          </div>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper animated" :class="menuClass" v-if="showNav">
          <li
            v-for="(item, index) in mNavList"
            :key="index"
            :class="item.path == $route.fullPath ? 'active' : ''"
            @click="navClick(index, item.name)"
          >
            <a :href="item.path">{{ item.name }}</a>
          </li>
          <div v-if="!isLogin">
            <li><a :href="loginUrl">登录</a></li>
            <li><a :href="registerUrl">注册</a></li>
            <li>
              <div class="bs-btn"><a :href="bluestoneH5Root + '/createAccount/index'">极速开户</a></div>
            </li>
          </div>
          <div v-else>
            <li @click="logout">退出</li>
            <li>
              <div class="bs-btn">
                <a :href="buttonObj && buttonObj.link">{{ buttonObj && buttonObj.text }}</a>
              </div>
            </li>
          </div>
        </ul>
        <!-- 登录后 内容 -->
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" size="tiny" :modal="false" id="qrcodeModal">
      <div class="header text-center">
        <h2>请扫描二维码进行 {{ isOpenAccount ? '入金' : '开户' }}</h2>
      </div>
      <div class="body">
        <div class="qrcode-wrap">
          <vue-qr
            v-show="!isOpenAccount"
            :text="openAccountUrl"
            :margin="0"
            colorDark="#000"
            colorLight="#fff"
            :logoSrc="logoUrl"
            :size="150"
          ></vue-qr>
          <vue-qr
            v-show="isOpenAccount"
            :text="depositUrl"
            :margin="0"
            colorDark="#000"
            colorLight="#fff"
            :logoSrc="logoUrl"
            :size="150"
          ></vue-qr>
        </div>
      </div>
      <div class="footer">
        <p class="qrcode-desc">零资金门槛，极速开户投全球</p>
        <p class="qrcode-tip">注：使用手机扫描二维码， {{ isOpenAccount ? '入金' : '开户' }}流程将在手机上进行</p>
      </div>
    </el-dialog>
    <div ref="openAccountQrcode"></div>
    <div ref="depositQrcode"></div>
  </div>
</template>
<script>
import { bluestoneH5Root } from '@/config/index.js'
import * as $http from '@/api/api.js'
import { getUrlQuery } from '@/utils/common.js'
import vueQr from 'vue-qr'
export default {
  name: 'Header',
  components: {
    vueQr
  },
  data() {
    return {
      bluestoneH5Root:bluestoneH5Root,
      menuName: '首页',
      menuClass: '',
      menuBtnClass: '',
      showNav: false,
      dialogVisible: false,
      navList: [
        {
          name: '首页',
          path: '/home'
        },
        {
          name: '产品与服务',
          path: '/download'
        },
        {
          name: '帮助',
          path: '/help'
        },
        {
          name: '关于我们',
          path: '/about'
        }
      ],
      mNavList: [],
      buttonMap: [
        {
          arr: ['0', '5', '20', '10', '-20'],
          text: '开户审核中',
          link: bluestoneH5Root + '/createAccount/result'
        },
        {
          arr: ['30'],
          text: '马上入金',
          link: '/userCenter/deposit'
        },
        {
          arr: ['-1'],
          text: '极速开户',
          link: bluestoneH5Root + '/createAccount'
        },
        {
          arr: ['-10'],
          text: '审核失败',
          link: bluestoneH5Root + '/createAccount/result'
        }
      ],
      buttonObj: {
        text: '',
        link: ''
      },
      userInfo: {
        // 用户信息,这里命名避免页面报错
        email: '',
        email_auth: '',
        nick_name: '',
        phone: '',
        phone_auth: '',
        region_code: '',
        qq_auth: '',
        user_id: '',
        wechat_auth: '',
        weibo_auth: ''
      },
      accountInfo: {
        // 客户信息
        open_account_status: '',
        name_pinyin: '',
        certificate_type: '',
        client_id: ''
      },
      cashInfo: [], //资金账户信息
      openAccountUrl:'http:' + bluestoneH5Root + '/createAccount/index',
      depositUrl:'http:' + bluestoneH5Root + '/userCenter/deposit?bs_session=' + cookieStore.get('bs_session'),
      logoUrl: require('@/assets/img/APPlogo.png')
    }
  },
  computed: {
    vindex() {
      return this.navList.filter(item => item.link === this.$route.fullPath)[0]
    },
    isLogin() {
      // 是否登录
      return cookieStore.get('bs_session') && this.userInfo
    },
    loginUrl() {
      return  bluestoneH5Root + '/login?backUrl=' + encodeURIComponent(location.href) + '&_appAdd=100'
    },
    registerUrl() {
      return  bluestoneH5Root + '/register?backUrl=' + encodeURIComponent(location.href) + '&_appAdd=100'
    },
    isOpenAccount() {
      return this.accountInfo.open_account_status == '30'
    }
  },
  watch: {
    vindex(val) {
      console.log(val)
    },
    accountInfo(val) {
      if (val) {
        let arr = this.buttonMap.filter(item => item.arr.includes(val.open_account_status.toString()))
        this.buttonObj = arr[0]
      }
    },
    isLogin(val) {
      if (val) {
        const navArr = this.mNavList.filter(item => item.name === '我的青石')
        if (navArr.length == 0) {
          // 没有就推
          this.mNavList.push({
            name: '我的青石',
            path: '/userCenter'
          })
        }
      } else {
        this.mNavList = JSON.parse(JSON.stringify(this.navList))
      }
    }
  },
  created() {
    console.log(this.openAccountUrl, this.depositUrl)
    this.init()
  },
  beforeDestroyed() {
    document.removeEventListener('click', this.bodyCloseMenus)
  },
  mounted() {
    document.addEventListener('click', this.bodyCloseMenus)
  },
  methods: {
    async init() {
      const token = getUrlQuery('bs_session') || cookieStore.get('bs_session')
      if (token) {
        // 如果有token，直接去查用户信息
        await this.getUserInfo()
        await this.getAccountInfo()
      }
      let arr = this.buttonMap.filter(item => item.arr.includes(this.accountInfo.open_account_status.toString()))
      this.buttonObj = arr[0]
      // 登录统一走bluestoneH5 ,登录成功bs_session,user_id写入cookie
      // cookies
      this.mNavList = JSON.parse(JSON.stringify(this.navList))
      if (this.isLogin) {
        this.mNavList.push({
          name: '我的青石',
          path: '/userCenter'
        })
      }
    },
    // 获取用户信息
    getUserInfo() {
      return new Promise(resolve => {
        $http.getUserInfo().then(res => {
          if (res.errno == 0) {
            this.userInfo = Object.assign(this.userInfo, res.body)
          }
          resolve()
        })
      })
    },
    // 获取客户信息
    getAccountInfo() {
      return new Promise(resolve => {
        $http.getAccountInfo().then(res => {
          if (res.errno == 0) {
            this.accountInfo = Object.assign(this.accountInfo, res.body.security_info)
            let arr = this.buttonMap.filter(item => item.arr.includes(this.accountInfo.open_account_status.toString()))
            this.buttonObj = arr[0]
          }
          resolve()
        })
      })
    },
    openDialog() {
      this.dialogVisible = true
    },
    // 退出登录
    logout() {
      // 清除cookie
      cookieStore.remove('bs_session')
      cookieStore.remove('nick_name')
      cookieStore.remove('region_code')
      cookieStore.remove('user_id')
      this.isLogin = false
      // 回到首页
      location.href = './'
    },
    bodyCloseMenus(e) {
      const mNav = this.$refs.mNav
      if (!mNav.contains(e.target)) {
        this.menuBtnClass = ''
        this.menuClass = 'fadeOutRight'
      }
    },
    navClick(index, name) {
      this.menuName = name
      this.menuClick()
    },
    menuClick() {
      this.showNav = true
      if (this.menuBtnClass == '') {
        this.menuBtnClass = 'btn-close'
        this.menuClass = 'fadeInRight'
      } else {
        this.menuBtnClass = ''
        this.menuClass = 'fadeOutRight'
      }
    }
  }
}
</script>
<style scoped lang="scss">
/* 顶部 */
#header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #000;
  transition: all ease 0.6s;
  z-index: 90;
  #qrcodeModal /deep/.el-dialog {
    width: 380px;
    .el-dialog__body {
      padding-top: 0;
    }
  }
  #qrcodeModal {
    h2 {
      color: #184b86;
      font-size: 24px;
      line-height: 33px;
    }
    .qrcode-wrap {
      text-align: center;
      margin: 20px;
    }
    .qrcode-desc {
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #184b86;
      text-align: center;
    }
    .qrcode-tip {
      font-family: PingFangSC-Light;
      font-size: 12px;
      color: #9ea5b1;
      text-align: center;
      margin-top: 20px;
    }
  }
  /* 导航栏 */
  .header-nav {
    height: 70px;
    /* 导航栏logo */
    .header-nav-logo {
      height: 100%;
      float: left;
      position: relative;
      line-height: 70px;
      margin-right: 150px;
      img {
        height: 40px;
        display: inline-block;
      }
    }
    .header-nav-wrapper {
      line-height: 70px;
      float: left;
      margin: 0;
      li {
        float: left;
        margin: 0 20px;
        position: relative;
        &.active::after {
          display: block;
        }
        // a 链接的下划线
        &::after {
          display: none;
          content: '';
          position: absolute;
          bottom: 12px;
          left: 50%;
          width: 26px;
          height: 4px;
          margin-left: -13px;
          background-color: #fff;
        }
        a {
          &:hover {
            color: #70a0ff;
          }
          color: #fff;
          font-size: 14px;
          padding: 15px 0;
          position: relative;
        }
      }
      &.header-user-nav {
        float: right;
        .user-name-box {
          a {
            display: inline-block;
            max-width: 60px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            padding: 0;
            vertical-align: middle;
          }
        }
      }
      &.user-login {
        li {
          &:hover {
            .icon-arrow_white {
              transform: rotate(0deg);
            }
            .user-hover-box {
              display: block;
            }
          }
          position: relative;
          &:first-child {
            text-align: left;
          }
          .icon-arrow_white {
            margin-left: 5px;
          }
          .user-hover-box {
            display: none;
            width: 260px;
            padding: 0 35px;
            background-color: #fff;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
            position: absolute;
            left: -80px;
            top: 70px;
            li {
              display: block;
              width: 190px;
              height: 50px;
              border-bottom: 1px solid #e5e5e5;
              margin-left: 0;
              line-height: 50px;
              text-align: center;
              i {
                vertical-align: middle;
                margin: -5px 5px 0 0;
              }
              a {
                color: #666;
                &.highlight {
                  color: #1243a3;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 997px) {
  #header {
    .header-nav-m {
      height: 50px;
      line-height: 50px;
      padding: 0 20px;
      position: relative;
      .header-nav-m-logo {
        img {
          display: inline-block;
          height: 30px;
        }
      }
      #menu {
        // display: none;
        opacity: 0;
        position: absolute;
        left: auto;
        top: 50px;
        right: 0;
        padding-bottom: 15px;
        width: 180px;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        background-color: #f7f7f7;
        color: #1e2731;
        z-index: 999;

        li {
          &.active {
            background: #fff;
            a {
              color: #1f50b1;
            }
          }
          padding: 0 15px;
          line-height: 44px;
          display: block;
          text-align: left;
          .bs-btn {
            width: 100%;
            a {
              color: #fff;
            }
          }
          a {
            color: #1e2731;
            display: block;
          }
        }
      }
      .btn-menu {
        position: absolute;
        top: 13px;
        right: 20px;
        width: 22px;
        height: 22px;
        overflow: hidden;
        span {
          height: 3px;
          width: 100%;
          background: #fff;
          margin: 3px 0;
          display: block;
          transition: all 0.5s;
        }
      }
      // 关闭
      .btn-close {
        span {
          &:nth-child(1) {
            transform: rotate(45deg) translate3d(5px, 5px, 0);
          }
          &:nth-child(2) {
            transform: translate3d(50px, 0, 0);
          }
          &:nth-child(3) {
            margin-top: 5px;
            transform: rotate(-45deg) translate3d(5px, -5px, 0);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue